<template>
  <Dialog v-model:open="isOpen" content-class="w-80" :close-on-overlay-click="false">
    <div class="flex flex-col items-center w-full">
      <div v-if="instruction" class="text-m-medium text-center whitespace-pre-line">
        {{ instruction }}
      </div>
      <div v-if="!hideInstruction" class="flex items-center gap-1 text-m-medium">
        <Icon icon="Function-Wireframe-Clock" class="size-4"></Icon>
        3s
      </div>
      <img v-show="status === 1" :src="pairingImg" class="w-52 h-52" />
      <img v-show="status === 2" :src="sucImg" class="w-52 h-52" />
      <img v-show="status === 3" :src="failImg" class="w-52 h-52" />
      <div v-show="status === 2" class="text-m-medium text-text-active">
        {{ t('setting.pairing.dialog.success') }}
      </div>
      <div v-show="status === 3" class="text-m-medium text-state-failure">
        {{ t('setting.pairing.dialog.fail') }}
      </div>
    </div>
    <div class="w-full flex items-center gap-2">
      <Button v-show="status === 3" class="flex-1" color="text-b-w" @click="closeDialog">
        {{ t('setting.pairing.dialog.cancel') }}
      </Button>
      <Button class="flex-1" color="black" :disabled="status === 1" @click="handleConfim">
        {{ buttonStr }}
      </Button>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'

  import { Dialog, Icon, Button } from '@rapoo/element'
  import pairingImg from '@/assets/images/header/settings/pairing/pairing.webp'
  import sucImg from '@/assets/images/header/settings/pairing/pair-success.png'
  import failImg from '@/assets/images/header/settings/pairing/pair-fail.png'
  import { useLocaleStore } from '@/stores'

  const { t } = useLocaleStore()

  const props = defineProps({
    status: {
      type: Number,
      default: 0,
    },
    deviceType: String,
    hideInstruction: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['restart', 'reset'])

  const instruction = computed(() => {
    if (props.hideInstruction) return t('setting.pairing.dialog.instructionAutoPairing')
    if (props.deviceType === 'mouse') return t('setting.pairing.dialog.instructionMouse')
    if (props.deviceType === 'keyboard')
      return t('setting.pairing.dialog.instructionKeyboard', { combinedKeys: 'Fn + 4' })

    return ''
  })

  const buttonStr = computed(() => {
    if (props.status === 1) {
      return t('setting.pairing.dialog.pairing')
    } else if (props.status === 3) {
      return t('setting.pairing.dialog.retry')
    } else {
      return t('setting.pairing.dialog.confirm')
    }
  })

  const handleConfim = () => {
    if (props.status === 3) {
      emit('restart')
    }
    if (props.status === 2) {
      closeDialog()
    }
  }

  const isOpen = ref(false)

  const openDialog = () => {
    isOpen.value = true
  }
  const closeDialog = () => {
    isOpen.value = false
    emit('reset')
  }
  defineExpose({
    openDialog,
    closeDialog,
  })
</script>
